import React from "react";
import { Card } from "./ui/card";
import { Wrench, Image as ImageIcon, Blinds, Home, Truck } from "lucide-react";

const Services = ({ language }) => {
  const content = {
    es: {
      title: "Servicios",
      subtitle: "Estos son los servicios que ofrezco en Valencia y alrededores",
      services: [
        {
          icon: Wrench,
          title: "Montaje y desmontaje de muebles",
          subtitle: "IKEA, etc.",
          description: "Assembly & disassembly of furniture (IKEA, etc.)",
        },
        {
          icon: ImageIcon,
          title: "Instalación de cortinas, estanterías, cuadros y TV",
          subtitle: "",
          description:
            "Installation of curtains, shelves, pictures & TV mounting",
        },
        {
          icon: Blinds,
          title: "Reparación básica de persianas",
          subtitle: "atascos, ajustes",
          description: "Basic blind repairs (jams, adjustments)",
        },
        {
          icon: Home,
          title: "Reparaciones del hogar",
          subtitle: "bisagras, tornillos, ajustes",
          description: "Home repairs (hinges, screws, adjustments)",
        },
        {
          icon: Truck,
          title: "Ayuda con mudanzas",
          subtitle: "desmontar / transportar / montar",
          description: "Moving help (disassemble / transport / assemble)",
        },
      ],
    },
    en: {
      title: "Services",
      subtitle: "These are the services I offer in Valencia and nearby areas",
      services: [
        {
          icon: Wrench,
          title: "Assembly & disassembly of furniture",
          subtitle: "IKEA, etc.",
          description: "Montaje y desmontaje de muebles (IKEA, etc.)",
        },
        {
          icon: ImageIcon,
          title: "Installation of curtains, shelves, pictures & TV",
          subtitle: "mounting",
          description: "Instalación de cortinas, estanterías, cuadros y TV",
        },
        {
          icon: Blinds,
          title: "Basic blind repairs",
          subtitle: "jams, adjustments",
          description: "Reparación básica de persianas (atascos, ajustes)",
        },
        {
          icon: Home,
          title: "Home repairs",
          subtitle: "hinges, screws, adjustments",
          description: "Reparaciones del hogar (bisagras, tornillos, ajustes)",
        },
        {
          icon: Truck,
          title: "Moving help",
          subtitle: "disassemble / transport / assemble",
          description: "Ayuda con mudanzas (desmontar / transportar / montar)",
        },
      ],
    },
  };

  const currentContent = content[language];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white" id="services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {currentContent.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {currentContent.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {currentContent.services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={index}
                className="service-card p-6 border border-gray-200 rounded-xl hover:border-[#2563EB] shadow-sm"
              >
                <div className="flex flex-col items-center text-center">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-[#2563EB]" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {service.title}
                  </h3>

                  {/* Subtitle */}
                  {service.subtitle && (
                    <p className="text-sm text-[#2563EB] font-medium mb-3">
                      {service.subtitle}
                    </p>
                  )}

                  {/* Description (other language) */}
                  <p className="text-sm text-gray-500 italic">
                    {service.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
